import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase/client'
import type { ProjectRole } from '../context/project-role-context'

async function fetchProjectRole(projectId: string, userId: string): Promise<ProjectRole> {
  const { data, error } = await supabase
    .from('project_memberships')
    .select('role')
    .eq('project_id', projectId)
    .eq('user_id', userId)
    .eq('is_removed', false)
    .maybeSingle()

  if (error) throw error
  return (data?.role as ProjectRole) ?? null
}

export function useProjectMembershipQuery(projectId: string | undefined, userId: string | undefined) {
  return useQuery({
    queryKey: ['project-membership', projectId, userId],
    queryFn: () => fetchProjectRole(projectId!, userId!),
    enabled: !!projectId && !!userId,
    staleTime: 5 * 60 * 1000,
  })
}
